import { request, requestList, buildQuery, orgBase } from '@/api/http'
import type { OrgDefaults, WeightPack, FxRate, Impact, ROIResult } from '@/api/types'

export const economicsApi = {
  getDefaults(orgId: string): Promise<OrgDefaults> {
    return request(`${orgBase(orgId)}/economics/defaults`)
  },
  setDefaults(orgId: string, body: OrgDefaults): Promise<OrgDefaults> {
    return request(`${orgBase(orgId)}/economics/defaults`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
  },
  weightPacks(orgId: string): Promise<WeightPack[]> {
    return requestList(`${orgBase(orgId)}/economics/weight-packs`)
  },
  activeWeightPack(orgId: string): Promise<{ weight_pack: string; weights: number[] }> {
    return request(`${orgBase(orgId)}/economics/weight-pack`)
  },
  setWeightPack(orgId: string, weightPack: string): Promise<OrgDefaults> {
    return request(`${orgBase(orgId)}/economics/weight-pack`, {
      method: 'PUT',
      body: JSON.stringify({ weight_pack: weightPack }),
    })
  },
  fxRates(orgId: string): Promise<Record<string, FxRate>> {
    return request(`${orgBase(orgId)}/economics/fx-rates`)
  },
  setFxRates(orgId: string, body: Record<string, FxRate>): Promise<Record<string, FxRate>> {
    return request(`${orgBase(orgId)}/economics/fx-rates`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
  },
  // Hierarchical $-at-risk for treemap / sunburst (org → inv → source → asset).
  inventoryImpact(
    orgId: string,
    invId: string,
    rate: 'total' | 'daily' | 'hourly' | 'exposure' = 'total'
  ): Promise<Impact> {
    return request(`${orgBase(orgId)}/inventories/${invId}/impact${buildQuery({ rate })}`)
  },
  lastChanged(orgId: string): Promise<{ changed_at: string | null }> {
    return request(`${orgBase(orgId)}/economics/last-changed`)
  },
  remediationRoi(orgId: string, invId: string): Promise<ROIResult> {
    return request(`${orgBase(orgId)}/inventories/${invId}/remediation-roi`)
  },
  simulateAssetRoi(orgId: string, assetId: string): Promise<ROIResult> {
    return request(`${orgBase(orgId)}/assets/${assetId}/remediation-roi/simulate`, {
      method: 'POST',
    })
  },
}
